import actions from '@/core/store/relatorios/controle-adesoes/actions'

export default {
	actions,
}
